// extracted by mini-css-extract-plugin
module.exports = {"root":"Choice_root__1Vs4d","dragIcon":"Choice_dragIcon__12GzN","left":"Choice_left__2Lip9","input":"Choice_input__3WCrR"};